import styled from 'styled-components';

const HeadingStyles = styled.section`
  padding: 3.69rem ${props => props.theme.padding.inner} 3.31rem;
  background: ${props => props.background || 'rgba(0, 0, 0, .05)'};
  color: ${props =>
    props.appearance
      ? props.appearance === 'light'
        ? props.theme.colors.white
        : props.theme.colors.bedtime
      : props.theme.colors.bedtime};
  overflow: visible !important;
  position: relative;

  > .inner {
    margin: auto;
    text-align: center;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.header};
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateY(10px);

        .active& {
          animation: 0.4s ease-in-out slide-in-up forwards;
        }
      }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: inherit;
    }

    > * {
      color: ${props =>
        props.appearance === 'light' ? 'inherit' : props.theme.colors.bedtime};
    }

    h1 {
      margin: 0;
    }
  }

  ${props => props.theme.animations.slideInUp};
`;

export default HeadingStyles;
